import { differenceInCalendarDays, format, isSameYear } from "date-fns";

import type { HourCycle } from "../components/ui/calendar.tsx";

/** Null past a week either way. */
export function nearDayWords(day: Date, now: Date = new Date()): string | null {
  const ahead = differenceInCalendarDays(day, now);
  if (ahead === 0) return "Today";
  if (ahead === 1) return "Tomorrow";
  if (ahead === -1) return "Yesterday";
  if (ahead < -1 && ahead > -7) return `${-ahead} days ago`;
  if (ahead > 1 && ahead < 7) return format(day, "EEEE");
  return null;
}

export function formatClock(day: Date, hourCycle: HourCycle = 12): string {
  return format(day, hourCycle === 24 ? "HH:mm" : "h:mm a");
}

export type FormatDayOptions = {
  time?: boolean;
  hourCycle?: HourCycle;
  /** Off for a record read later, where "Tomorrow" would name the wrong day. */
  relative?: boolean;
  dropYear?: boolean;
};

export function formatDay(
  day: Date,
  { time = false, hourCycle = 12, relative = false, dropYear = true }: FormatDayOptions = {},
): string {
  const now = new Date();
  const words =
    (relative ? nearDayWords(day, now) : null) ??
    format(day, dropYear && isSameYear(day, now) ? "MMM d" : "MMM d, yyyy");
  return time ? `${words} at ${formatClock(day, hourCycle)}` : words;
}
